import type { VisualizationType } from '@tempo-io/roadmap-dto';

export type VisualizationUrlSegment = 'swimlane' | 'timeline' | 'table' | 'node-graph';

export function visualizationTypeToUrlSegment(type: VisualizationType): VisualizationUrlSegment {
  if (type === 'nodeGraph') return 'node-graph';
  return type;
}

const VISUALIZATION_TYPE_BY_URL_SEGMENT: Record<VisualizationUrlSegment, VisualizationType> = {
  swimlane: 'swimlane',
  timeline: 'timeline',
  table: 'table',
  'node-graph': 'nodeGraph',
};

export function urlSegmentToVisualizationType(segment: string): VisualizationType | undefined {
  return VISUALIZATION_TYPE_BY_URL_SEGMENT[segment as VisualizationUrlSegment];
}
